import { IDashboardItem } from '@ifit/gateway-wolf-dashboard-service';
import { UseQueryResult } from 'react-query';
import { getFallbackMarketingItems } from '../../data/fallback-data/get-fallback-marketing-items';
import { useMarketingStaffPicks } from './use-staff-picks';

export function useMarketingItems(): UseQueryResult<IDashboardItem[], Error> {
  const staffPicksQuery = useMarketingStaffPicks();

  const { data: staffPicks } = staffPicksQuery;

  let marketingItems;

  if (staffPicksQuery.isSuccess) {
    marketingItems = staffPicks.length === 0 ? getFallbackMarketingItems() : staffPicks;
  }

  if (staffPicksQuery.isError) {
    marketingItems = getFallbackMarketingItems();
  }

  return { ...staffPicksQuery, data: marketingItems };
}
